import * as React from 'react';
import * as adminStyles from '../AdminStyles.css';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../../stores';
import { IATextField } from '../../../textField/TextField';
import { IAToggle } from '../../../toggle/Toggle';
import { IAIcon } from '../../../icon/Icon';
import { Environment } from '../../../../services/Environment';
import { Utils } from '../Utils';
import { TreeTargeting } from '../../../treeTargeting/TreeTargeting';
import { IADropDown } from '../../../dropDown/DropDown';
import * as Constants from "../../Constants";
import NavigatorService from '../../../../services/NavigatorService';
import { IInstance } from '../../../../interfaces/IInstance';
import { IANumberField } from '../../../numberField/NumberField';
import { ITargetingApplications } from '../../../../interfaces/ITargetingApplications';
import TargetingUtils from '../../../treeTargeting/utils';
import { IAOptionSelector } from '../../../optionSelector/OptionSelector';
import { IAColorPicker } from '../../../colorPicker/ColorPicker';
import { IATermCheckbox } from '../../../termCheckBox/TermCheckbox';
import { LocalizationService } from '../../../../services/LocalizationService';
import { Helper } from '../../../../Helper';
import { IACodeEditor } from '../../../codeEditor/CodeEditor';
import { IAIconPicker } from '../../../iconPicker/IconPicker';
import TopItemSettingsAiConfiguration from './TopItemSettingsAiConfiguration';
import { TreeTargetingForGroups } from '../../../treeTargetingForGroups';

export interface ITopItemSettingsPanelProps {
  navigatorStore?: NavigatorStore;
}

export interface ITopItemSettingsPanelState {
  instances: any;
  applicationSettings: ITargetingApplications;
  isSiteCollectionInValid: boolean;
  categoryValues: any[];
}

@inject('navigatorStore')
@observer
export default class TopItemSettingsPanel extends React.Component<ITopItemSettingsPanelProps, ITopItemSettingsPanelState> {
  private localizationService = new LocalizationService();
  private selectedValues: any[];

  constructor(props: ITopItemSettingsPanelProps) {
    super(props);
    this.state = {
      instances: undefined,
      applicationSettings: null,
      isSiteCollectionInValid: false,
      categoryValues: undefined,
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  private getChildCategories(category: any): any[] {
    if (category) {
      const childCategories = [];
      category.forEach((childData: any) => {
        childCategories.push(
          {
            defaultLabel: childData.name,
            id: childData.guid,
            childNodes: this.getChildCategories(childData.children)
          }
        );
      });
      return childCategories;
    } else {
      return undefined;
    }
  }

  public render(): JSX.Element {
    if (this.props.navigatorStore.isShowingTopItemSettings) {
      let selectedTopItem;
      if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
        selectedTopItem = this.props.navigatorStore.navigator.megamenu.topItems[this.props.navigatorStore.topItemIndexToEdit];
      } else if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
        selectedTopItem = this.props.navigatorStore.navigator.smartmenu.elements[this.props.navigatorStore.smartmenuTopItemIndexToEdit];
      }
      this.selectedValues = undefined;
      if (selectedTopItem !== undefined && selectedTopItem.targeting !== undefined && this.props.navigatorStore.applicationSettings) {
        this.selectedValues = Utils.parseSelectedTargetingValues(selectedTopItem.targeting, this.props.navigatorStore.applicationSettings?.applicationSettings);
      }
      if (selectedTopItem !== undefined && (selectedTopItem.type === undefined || selectedTopItem.type === "link")) {
        selectedTopItem.type = "menu";
      } else if (selectedTopItem == undefined) {
        selectedTopItem = {
          type: "menu",
          title: ""
        };
      }
      if (selectedTopItem !== undefined && selectedTopItem.type == "event" || selectedTopItem.type == "contentcreator") {
        let site = undefined;
        switch (selectedTopItem.type) {
          case "event":
            site = "IntraActive-Events"
            break;
          case "contentcreator":
            site = "IntraActive-ContentCreator"
            break;
          default:
            break;
        }
        if (this.props.navigatorStore.instances == undefined) {
          NavigatorService.getInstances(this.props.navigatorStore.token, this.props.navigatorStore.tenant, this.props.navigatorStore.environment, site).then((instances: any[]) => {
            this.props.navigatorStore.instances = instances;
            let availableInstances = [];
            instances.forEach((instance: IInstance) => {
              availableInstances.push({
                key: instance.instanceName,
                value: instance.title
              });
            });
            if (instances.length > 0) {
              if (selectedTopItem.config.instance == undefined) {
                selectedTopItem.config.instance = instances[0];
              }
              this.setState({ instances: availableInstances });
            }
          });
        } else {
          if (this.props.navigatorStore.instances.length > 0 && selectedTopItem.config.instance == undefined) {
            selectedTopItem.config.instance = this.props.navigatorStore.instances[0];
          }
        }
      }

      // Checking if targeting is enabled
      const showTargetOptions = TargetingUtils.checkIfUsesTargeting(this.props.navigatorStore.applicationSettings, this.props.navigatorStore.instance);

      let top = 51;
      switch (Helper.getDisplayEnvironment()) {
        case "ExternalEnvironment":
          top = 51;
          break;
        case "Sharepoint":
          top = 161;
          break;
      }

      const peopleFinderIndex = Constants.TOP_ITEM_TYPES.findIndex(v => v.key === "peoplefinder");
      if (!this.props.navigatorStore.tenantSettings?.peopleFinder?.enabled && peopleFinderIndex != -1) {
        Constants.TOP_ITEM_TYPES.splice(peopleFinderIndex, 1);
      }

      const pages = [];
      if (this.props.navigatorStore.droppableSmartmentTopItemSpotsAreShowing) {
        //props.navigatorStore.navigator.smartmenu.elements
        this.props.navigatorStore.navigator.smartmenu.elements?.forEach((item, index) => {
          pages.push(
            <div
              className={adminStyles.IA_sortingPage}
              key={index}
            >
              {item.config.icon && item.config.icon !== "" && <IAIcon
                title={item.config.icon}
                size={18}
                color={"#333333"}
                style={{
                  float: "left",
                  marginTop: 16,
                  marginLeft: 16
                }}
              />}
              <div
                className={adminStyles.IA_sortingPageText}
                style={{
                  color: item.config.title ? "#333333" : "#999999"
                }}
              >
                {item.config.title}
              </div>
              <IAIcon
                url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg"
                size={18}
                color={index < this.props.navigatorStore.navigator.smartmenu.elements.length - 1 ? "#23879b" : "#eeeeee"}
                onClick={() => {
                  if (index < this.props.navigatorStore.navigator.smartmenu.elements.length - 1) {
                    var element = this.props.navigatorStore.navigator.smartmenu.elements[index];
                    this.props.navigatorStore.navigator.smartmenu.elements.splice(index, 1);
                    this.props.navigatorStore.navigator.smartmenu.elements.splice(index + 1, 0, element);
                    this.props.navigatorStore.checkForChanges();
                    // this.props.hasChanged();
                  }
                }}
                style={{
                  float: "right",
                  marginTop: 16,
                  marginRight: 16,
                  cursor: index < this.props.navigatorStore.navigator.smartmenu.elements.length - 1 ? "pointer" : "default"
                }}
              />
              <IAIcon
                url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg"
                size={18}
                color={index === 0 || (this.props.navigatorStore.navigator.smartmenu.elements[index]?.type === "IntraActive-NavigatorAdmin" && index === 1) || (this.props.navigatorStore.navigator.smartmenu.elements[index]?.type === "IntraActive-ContentOrganizer" && index === 1) ? "#eeeeee" : "#23879b"}
                onClick={() => {
                  if (index === 0 || (this.props.navigatorStore.navigator.smartmenu.elements[index]?.type === "IntraActive-NavigatorAdmin" && index === 1) || (this.props.navigatorStore.navigator.smartmenu.elements[index]?.type === "IntraActive-ContentOrganizer" && index === 1)) {
                  } else {
                    var element = this.props.navigatorStore.navigator.smartmenu.elements[index];
                    this.props.navigatorStore.navigator.smartmenu.elements.splice(index, 1);
                    this.props.navigatorStore.navigator.smartmenu.elements.splice(index - 1, 0, element);
                    this.props.navigatorStore.checkForChanges();
                    // this.props.hasChanged();
                  }
                }}
                style={{
                  float: "right",
                  marginTop: 16,
                  marginRight: 16,
                  cursor: index > 0 ? "pointer" : "default"
                }}
              />
            </div>
          );
        });
        pages.push(
          <div
            className={adminStyles.IA_sortingPage}
            onClick={() => {
              this.props.navigatorStore.closeReorderSmartMenu();
            }}
            style={{ backgroundColor: "#23879b", marginTop: "40px" }}
          >
            <IAIcon
              title={"Checkmark"}
              size={18}
              color={"#ffffff"}
              style={{
                float: "left",
                marginTop: 16,
                marginLeft: 16
              }}
            />
            <div
              className={adminStyles.IA_sortingPageText}
              style={{
                color: "#ffffff"
              }}
            >
              {this.props.navigatorStore.droppableSmartmentTopItemSpotsAreShowing ? this.localizationService.strings.Navigator_Megamenu_DoneReordering : this.localizationService.strings.Navigator_Megamen_ReorderTopItems}
            </div>
          </div>
        );
      }

      if (this.props.navigatorStore.droppableTopItemSpotsAreShowing) {
        //props.navigatorStore.navigator.smartmenu.elements
        this.props.navigatorStore.navigator.megamenu.topItems?.forEach((item, index) => {
          pages.push(
            <div
              className={adminStyles.IA_sortingPage}
              key={index}
            >
              {item.config.icon && item.config.icon !== "" && <IAIcon
                title={item.config.icon}
                size={18}
                color={"#333333"}
                style={{
                  float: "left",
                  marginTop: 16,
                  marginLeft: 16
                }}
              />}
              <div
                className={adminStyles.IA_sortingPageText}
                style={{
                  color: item.config.title ? "#333333" : "#999999"
                }}
              >
                {item.config.title}
              </div>
              <IAIcon
                url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg"
                size={18}
                color={index < this.props.navigatorStore.navigator.megamenu.topItems.length - 1 ? "#23879b" : "#eeeeee"}
                onClick={() => {
                  if (index < this.props.navigatorStore.navigator.megamenu.topItems.length - 1) {
                    var element = this.props.navigatorStore.navigator.megamenu.topItems[index];
                    this.props.navigatorStore.navigator.megamenu.topItems.splice(index, 1);
                    this.props.navigatorStore.navigator.megamenu.topItems.splice(index + 1, 0, element);
                    this.props.navigatorStore.getTopItems();
                    // this.props.hasChanged();
                  }
                }}
                style={{
                  float: "right",
                  marginTop: 16,
                  marginRight: 16,
                  cursor: index < this.props.navigatorStore.navigator.megamenu.topItems.length - 1 ? "pointer" : "default"
                }}
              />
              <IAIcon
                url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg"
                size={18}
                color={index === 0 || (this.props.navigatorStore.navigator.megamenu.topItems[index]?.type === "IntraActive-NavigatorAdmin" && index === 1) || (this.props.navigatorStore.navigator.megamenu.topItems[index]?.type === "IntraActive-ContentOrganizer" && index === 1) ? "#eeeeee" : "#23879b"}
                onClick={() => {
                  if (index === 0 || (this.props.navigatorStore.navigator.megamenu.topItems[index]?.type === "IntraActive-NavigatorAdmin" && index === 1) || (this.props.navigatorStore.navigator.megamenu.topItems[index]?.type === "IntraActive-ContentOrganizer" && index === 1)) {
                  } else {
                    var element = this.props.navigatorStore.navigator.megamenu.topItems[index];
                    this.props.navigatorStore.navigator.megamenu.topItems.splice(index, 1);
                    this.props.navigatorStore.navigator.megamenu.topItems.splice(index - 1, 0, element);
                    this.props.navigatorStore.getTopItems();
                    // this.props.hasChanged();
                  }
                }}
                style={{
                  float: "right",
                  marginTop: 16,
                  marginRight: 16,
                  cursor: index > 0 ? "pointer" : "default"
                }}
              />
            </div>
          );
        });
        pages.push(
          <div
            className={adminStyles.IA_sortingPage}
            key={`topItemAddNewButton_${this.props.navigatorStore.navigator.megamenu.topItems.length}`}
            onClick={() => {
              this.props.navigatorStore.closeReorderTopItem();
              this.props.navigatorStore.selectTopMenuItem(undefined);
              this.props.navigatorStore.getTopItems();
            }}
            style={{ backgroundColor: "#23879b", marginTop: "40px" }}
          >
            <IAIcon
              title={"Checkmark"}
              size={18}
              color={"#ffffff"}
              style={{
                float: "left",
                marginTop: 16,
                marginLeft: 16
              }}
            />
            <div
              className={adminStyles.IA_sortingPageText}
              style={{
                color: "#ffffff"
              }}
            >
              {this.props.navigatorStore.droppableTopItemSpotsAreShowing
                ? this.localizationService.strings.Navigator_Megamenu_DoneReordering
                : this.localizationService.strings.Navigator_Megamen_ReorderTopItems}
            </div>
          </div>
        );
      }
      return (
        <div
          className={adminStyles.panel}
          style={{
            right: this.props.navigatorStore.isShowingTopItemSettings ? "0px" : "-400px",
            top: top,
            height: `calc(100% - ${top}px)`,
            overflowY: "hidden"
          }}
        >
          <div className={adminStyles.panelHeader}>
            {this.localizationService.strings.Navigator_Settings_TopItem}
            <IAIcon
              title={"Close"}
              size={20}
              color="#ffffff"
              onClick={() => {
                this.props.navigatorStore.topItemIndexToEdit = undefined;
                this.props.navigatorStore.smartmenuTopItemIndexToEdit = undefined;
                this.props.navigatorStore.closeReorderSmartMenu();
                this.props.navigatorStore.closeReorderTopItem();
                this.props.navigatorStore.toggleTopItemSettings();
              }}
              style={{
                float: "right",
                padding: "10px 10px 0",
                cursor: "pointer",
                lineHeight: 0
              }}
            />
          </div>

          <div
            style={{
              width: "100%",
              height: "100%",
              overflowY: "auto",
              padding: "0 20px 20px",
              boxSizing: "border-box"
            }}
          >
            {this.props.navigatorStore.isShowingTopItemSettings && !this.props.navigatorStore.droppableTopItemSpotsAreShowing &&
              !this.props.navigatorStore.droppableSmartmentTopItemSpotsAreShowing && selectedTopItem !== undefined &&
              <>
                {this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined &&
                  <IADropDown
                    label={this.localizationService.strings.Navigator_Content_TopItemType}
                    selectedOption={selectedTopItem?.type ?? undefined}
                    options={Constants.SMARTMENU_TOP_ITEM_TYPES.concat(this.props.navigatorStore.getCodeSnippetComponentIfEnabled()).concat(this.props.navigatorStore.getAIComponentIfEnabled()).concat(this.props.navigatorStore.getTargetedPreviewComponentIfEnabled())}
                    borderRadius={5}
                    onChange={(type: string) => {
                      this.props.navigatorStore.instances = undefined;
                      if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined && type) {
                        this.props.navigatorStore.setSmartmenuTopItemType(type.toLowerCase());
                      }
                      this.forceUpdate();
                    }}
                  />
                }
                {selectedTopItem && selectedTopItem.type === "celebration" &&
                  <IADropDown
                    label={this.localizationService.strings.Navigator_Content_CelebrationType}
                    selectedOption={selectedTopItem !== undefined && selectedTopItem.config !== undefined ? selectedTopItem.config.subType : undefined}
                    borderRadius={5}
                    options={[
                      {
                        key: 'snow',
                        value: 'Snow',
                      },
                      {
                        key: 'confetti',
                        value: 'Confetti',
                      },
                      {
                        key: 'easterconfetti',
                        value: this.localizationService.strings.Navigator_EasterConfetti,
                      },
                      {
                        key: 'halloweenconfetti',
                        value: "Halloween",
                      }
                    ]}
                    onChange={(subType: string) => {
                      if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined && subType) {
                        this.props.navigatorStore.setSmartmenuSubType(subType.toLowerCase());
                      }
                      this.forceUpdate();
                    }}
                  />
                }
                {this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined &&
                  <div className={adminStyles.panelDivider} />
                }
                <IATextField
                  label={this.localizationService.strings.Navigator_Content_Titel}
                  text={selectedTopItem.config.title}
                  borderRadius={5}
                  onChange={(title: string) => {
                    if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                      this.props.navigatorStore.setSmartmenuTopItemTitle(title);
                    } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                      this.props.navigatorStore.setTopItemTitle(title);
                    }
                    this.forceUpdate();
                  }}
                />
                <IAIconPicker
                  label={this.localizationService.strings.Navigator_Content_Icon}
                  selectedIcon={selectedTopItem.config.icon}
                  color={"#333333"}
                  select={(icon: string) => {
                    if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                      this.props.navigatorStore.setSmartmenuTopItemIcon(icon);
                    } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                      this.props.navigatorStore.setTopItemIcon(icon);
                    }
                    this.forceUpdate();
                  }}
                  shouldBeAbleToClear={this.props.navigatorStore.smartmenuTopItemIndexToEdit === undefined}
                  clear={() => {
                    if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                      this.props.navigatorStore.setSmartmenuTopItemIcon(undefined);
                    } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                      this.props.navigatorStore.setTopItemIcon(undefined);
                    }
                    this.forceUpdate();
                  }}
                />
                <div className={adminStyles.panelDivider} />
                {selectedTopItem.type === "menu" &&
                  <IATextField
                    label={this.localizationService.strings.Navigator_Content_UrlTopItem}
                    text={selectedTopItem.config.url}
                    borderRadius={5}
                    onChange={(url: string) => {
                      if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                        this.props.navigatorStore.setSmartmenuTopItemUrl(url);
                      } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                        this.props.navigatorStore.setTopItemUrl(url);
                      }
                      this.forceUpdate();
                    }}
                  />
                }
                {selectedTopItem.type === "menu" &&
                  <IAToggle
                    label={this.localizationService.strings.Navigator_Content_LinkOpen}
                    checked={selectedTopItem.config.openInNewWindow}
                    color={"#333333"}
                    onChange={() => {
                      if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                        this.props.navigatorStore.setSmartmenuTopItemOpenInNewWindow();
                      } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                        this.props.navigatorStore.setTopItemOpenInNewWindow();
                      }
                      this.forceUpdate();
                    }}
                    style={{
                      marginTop: 20
                    }}
                  />
                }
                {selectedTopItem.type === "code" &&
                  <IACodeEditor
                    label={this.localizationService.strings.Navigator_Content_CodeEditor}
                    code={selectedTopItem.config.code}
                    highlightColor={this.props.navigatorStore.adminColor}
                    required
                    onChange={(code: string) => {
                      if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                        this.props.navigatorStore.setSmartmenuTopItemCode(code);
                      } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                        this.props.navigatorStore.setTopItemCode(code);
                      }
                      this.forceUpdate();
                    }}
                  />
                }
                {selectedTopItem.type == "phonebook" &&
                  <>
                    <IATextField
                      label={this.localizationService.strings.Navigator_Content_SiteCollectionTopItem}
                      text={selectedTopItem.config.siteCollection}
                      borderRadius={5}
                      onChange={(siteCollection: string) => {
                        if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                          this.props.navigatorStore.setSmartmenuTopItemSiteCollection(siteCollection);
                        } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                          this.props.navigatorStore.setTopItemSiteCollection(siteCollection);
                        }
                        this.forceUpdate();
                      }}
                    />
                    <IATextField
                      label={this.localizationService.strings.Navigator_Content_ResultSource}
                      text={selectedTopItem.config.resultSource}
                      borderRadius={5}
                      onChange={(resultSource: string) => {
                        if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                          this.props.navigatorStore.setSmartmenuTopItemResultSource(resultSource);
                        } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                          this.props.navigatorStore.setTopItemResultSource(resultSource);
                        }
                        this.forceUpdate();
                      }}
                    />
                    {(/[^\dA-z\-\/]+/.test(selectedTopItem.config.siteCollection) || (selectedTopItem.config.siteCollection === "")) && // check if contain anything but "white space", letter, digit, -, /
                      <div style={{ color: 'red', fontSize: 14, marginTop: 10, float: 'left' }}>
                        {this.localizationService.strings.Navigator_Content_SiteCollectionInputWarning}
                      </div>
                    }
                  </>
                }
                {selectedTopItem && selectedTopItem.config && selectedTopItem.config.subType === "snow" &&
                  <IAToggle
                    label={this.localizationService.strings.Navigator_Content_EnableSnowByDefault}
                    checked={selectedTopItem.config.snowEnabled !== undefined ? selectedTopItem.config.snowEnabled : false}
                    color={this.props.navigatorStore.adminColor}
                    onChange={() => {
                      selectedTopItem.config.snowEnabled = selectedTopItem.config.snowEnabled != undefined ? !selectedTopItem.config.snowEnabled : true;
                      this.props.navigatorStore.checkForChanges();
                      this.forceUpdate();
                    }}
                    style={{
                      marginTop: 20
                    }}
                  />
                }
                {selectedTopItem && selectedTopItem.config && (selectedTopItem.config.subType === "confetti" || selectedTopItem.config.subType === "easterconfetti" || selectedTopItem.config.subType === "halloweenconfetti") &&
                  <IAToggle
                    label={this.localizationService.strings.Navigator_Content_EnableConfettiByDefault}
                    checked={selectedTopItem.config.confettiEnabled !== undefined ? selectedTopItem.config.confettiEnabled : false}
                    color={this.props.navigatorStore.adminColor}
                    onChange={() => {
                      selectedTopItem.config.confettiEnabled = selectedTopItem.config.confettiEnabled != undefined ? !selectedTopItem.config.confettiEnabled : true;
                      this.props.navigatorStore.checkForChanges();
                      this.forceUpdate();
                    }}
                    style={{
                      marginTop: 20
                    }}
                  />
                }
                {(selectedTopItem.type == "event" || selectedTopItem.type == "contentcreator") && this.state.instances &&
                  <>
                    <IADropDown
                      label={this.localizationService.strings.Navigator_Admin_SelectInstance}
                      selectedOption={selectedTopItem.config.instance != undefined ? selectedTopItem.config.instance.instanceName : undefined}
                      options={this.state.instances}
                      borderRadius={5}
                      onChange={(instanceName: string) => {
                        this.props.navigatorStore.instances.forEach((instance: IInstance) => {
                          if (instance.instanceName === instanceName) {
                            selectedTopItem.config.instance = instance;
                            this.props.navigatorStore.checkForChanges();
                            this.forceUpdate();
                          }
                        });

                        if (selectedTopItem.config.shouldFilterByCategory) {
                          selectedTopItem.config.shouldFilterByCategory = false;
                        }
                      }}
                      style={{
                        float: "left",
                        opacity: this.state.instances ? 1 : 0.5
                      }}
                    />
                  </>
                }
                {selectedTopItem.type == "event" && this.state.instances &&
                  <>
                    <IADropDown
                      label={this.localizationService.strings.Navigator_Admin_SelectPeriod}
                      selectedOption={selectedTopItem.config.showPeriod}
                      options={Constants.SHOW_PERIOD}
                      borderRadius={5}
                      onChange={(showPeriod: string) => {
                        selectedTopItem.config.showPeriod = showPeriod;
                        this.props.navigatorStore.checkForChanges();
                        this.forceUpdate();
                      }}
                      style={{
                        float: "left",
                        opacity: this.state.instances ? 1 : 0.5
                      }}
                    />
                    <div className={adminStyles.panelDivider} />
                    {selectedTopItem.config.showPeriod && selectedTopItem.config.showPeriod !== "fullView" &&
                      <IAOptionSelector
                        label={"Visningstype"}
                        options={[
                          {
                            icon: "Card view",
                            key: "Card view",
                            text: "Card view"
                          },
                          {
                            icon: "Thumbnail list",
                            key: "List view",
                            text: "List view",
                          }
                        ]}
                        selected={selectedTopItem.config.displayType != undefined ? selectedTopItem.config.displayType : "Card view"}
                        highlightColor={this.props.navigatorStore.adminColor}
                        borderRadius={5}
                        onChange={(option: string) => {
                          selectedTopItem.config.displayType = option;
                          this.props.navigatorStore.checkForChanges();
                          this.forceUpdate();
                        }}
                      />
                    }
                    {selectedTopItem.config.showPeriod && selectedTopItem.config.showPeriod !== "fullView" &&
                      <IANumberField
                        label={this.localizationService.strings.Navigator_Admin_AmountOfCardsPerPage}
                        number={selectedTopItem.config.numberOfEvents}
                        onChange={(numberOfEvents: number) => {
                          selectedTopItem.config.numberOfEvents = numberOfEvents;
                          this.props.navigatorStore.checkForChanges();
                          this.forceUpdate();
                        }}
                        borderRadius={5}
                        styles={{
                          width: "100%"
                        }}
                      />
                    }
                    {selectedTopItem.config.showPeriod && selectedTopItem.config.showPeriod !== "fullView" &&
                      <IAColorPicker
                        label={this.localizationService.strings.Navigator_Design_BackgroundColor}
                        color={selectedTopItem.config.backgroundColor}
                        onChange={(backgroundColor: string) => {
                          selectedTopItem.config.backgroundColor = backgroundColor;
                          this.props.navigatorStore.checkForChanges();
                          this.forceUpdate();
                        }}
                        styles={{
                          width: "100%"
                        }}
                        showClearButton={true}
                      />
                    }
                    {selectedTopItem.config.showPeriod && selectedTopItem.config.showPeriod !== "fullView" &&
                      <IAColorPicker
                        label={this.localizationService.strings.Navigator_Design_TextColor}
                        color={selectedTopItem.config.textColor}
                        onChange={(textColor: string) => {
                          selectedTopItem.config.textColor = textColor;
                          this.props.navigatorStore.checkForChanges();
                          this.forceUpdate();
                        }}
                        styles={{
                          width: "100%"
                        }}
                        showClearButton={true}
                      />
                    }
                    {selectedTopItem.config.displayType === "List view" && selectedTopItem.config.showPeriod !== "fullView" &&
                      <IAColorPicker
                        label={this.localizationService.strings.Navigator_Design_DateBadgeBackgroundColor}
                        color={selectedTopItem.config.dateBadgeBackgroundColor}
                        onChange={(dateBadgeBackgroundColor: string) => {
                          selectedTopItem.config.dateBadgeBackgroundColor = dateBadgeBackgroundColor;
                          this.props.navigatorStore.checkForChanges();
                          this.forceUpdate();
                        }}
                        styles={{
                          width: "100%"
                        }}
                        showClearButton={true}
                      />
                    }
                    {selectedTopItem.config.displayType === "List view" && selectedTopItem.config.showPeriod !== "fullView" &&
                      <IAColorPicker
                        label={this.localizationService.strings.Navigator_Design_DateBadgeTextColor}
                        color={selectedTopItem.config.dateBadgeTextColor}
                        onChange={(dateBadgeTextColor: string) => {
                          selectedTopItem.config.dateBadgeTextColor = dateBadgeTextColor;
                          this.props.navigatorStore.checkForChanges();
                          this.forceUpdate();
                        }}
                        styles={{
                          width: "100%"
                        }}
                        showClearButton={true}
                      />
                    }
                    {selectedTopItem.config.showPeriod && selectedTopItem.config.showPeriod !== "fullView" &&
                      <IAColorPicker
                        label={this.localizationService.strings.Navigator_Design_BorderColor}
                        color={selectedTopItem.config.borderColor}
                        onChange={(borderColor: string) => {
                          selectedTopItem.config.borderColor = borderColor;
                          this.props.navigatorStore.checkForChanges();
                          this.forceUpdate();
                        }}
                        styles={{
                          width: "100%"
                        }}
                        showClearButton={true}
                      />
                    }
                    {selectedTopItem.config.showPeriod && selectedTopItem.config.showPeriod !== "fullView" &&
                      <IAToggle
                        label={this.localizationService.strings.Navigator_Content_ShowDropShadow}
                        checked={selectedTopItem.config.showDropShadow !== undefined ? selectedTopItem.config.showDropShadow : false}
                        color={this.props.navigatorStore.adminColor}
                        onChange={() => {
                          selectedTopItem.config.showDropShadow = selectedTopItem.config.showDropShadow != undefined ? !selectedTopItem.config.showDropShadow : true;
                          this.props.navigatorStore.checkForChanges();
                          this.forceUpdate();
                        }}
                        style={{
                          marginTop: 20
                        }}
                      />
                    }
                    <IAToggle
                      label={this.localizationService.strings.Navigator_Content_AddMessage}
                      checked={selectedTopItem.config.addMessage !== undefined ? selectedTopItem.config.addMessage : true}
                      color={this.props.navigatorStore.adminColor}
                      onChange={() => {
                        selectedTopItem.config.addMessage = selectedTopItem.config.addMessage != undefined ? !selectedTopItem.config.addMessage : false;
                        this.props.navigatorStore.checkForChanges();
                        this.forceUpdate();
                      }}
                      style={{
                        marginTop: 20
                      }}
                    />
                    {selectedTopItem != undefined && !selectedTopItem.config.shouldFilterByCategory &&
                      <IAToggle
                        label={this.localizationService.strings.Navigator_Content_ShowFilter}
                        checked={selectedTopItem.config.showFilter !== undefined ? selectedTopItem.config.showFilter : false}
                        color={this.props.navigatorStore.adminColor}
                        onChange={() => {
                          selectedTopItem.config.showFilter = selectedTopItem.config.showFilter != undefined ? !selectedTopItem.config.showFilter : true;
                          this.props.navigatorStore.checkForChanges();
                          this.forceUpdate();
                        }}
                        style={{
                          marginTop: 20
                        }}
                      />
                    }
                    {selectedTopItem.config.showPeriod && selectedTopItem.config.showPeriod !== "fullView" &&
                      <IAToggle
                        label={this.localizationService.strings.Navigator_Content_ShowTimespand}
                        checked={selectedTopItem.config.showTimespand !== undefined ? selectedTopItem.config.showTimespand : true}
                        color={this.props.navigatorStore.adminColor}
                        onChange={() => {
                          selectedTopItem.config.showTimespand = selectedTopItem.config.showTimespand != undefined ? !selectedTopItem.config.showTimespand : false;
                          this.props.navigatorStore.checkForChanges();
                          this.forceUpdate();
                        }}
                        style={{
                          marginTop: 20
                        }}
                      />
                    }
                    {selectedTopItem.config.showPeriod && selectedTopItem.config.showPeriod !== "fullView" &&
                      <IAToggle
                        label={this.localizationService.strings.Navigator_Content_ShowCategories}
                        checked={selectedTopItem.config.showCategories !== undefined ? selectedTopItem.config.showCategories : true}
                        color={this.props.navigatorStore.adminColor}
                        onChange={() => {
                          selectedTopItem.config.showCategories = selectedTopItem.config.showCategories != undefined ? !selectedTopItem.config.showCategories : false;
                          this.props.navigatorStore.checkForChanges();
                          this.forceUpdate();
                        }}
                        style={{
                          marginTop: 20
                        }}
                      />
                    }
                    <IAToggle
                      label={this.localizationService.strings.Navigator_Content_ShowPaging}
                      checked={selectedTopItem.config.showPaging !== undefined ? selectedTopItem.config.showPaging : true}
                      color={this.props.navigatorStore.adminColor}
                      onChange={() => {
                        selectedTopItem.config.showPaging = selectedTopItem.config.showPaging != undefined ? !selectedTopItem.config.showPaging : false;
                        this.props.navigatorStore.checkForChanges();
                        this.forceUpdate();
                      }}
                      style={{
                        marginTop: 20
                      }}
                    />
                    <div className={adminStyles.panelDivider} />
                    <IAToggle
                      label={this.localizationService.strings.Navigator_Content_EnableLikes}
                      checked={selectedTopItem.config.enableLikes !== undefined ? selectedTopItem.config.enableLikes : true}
                      color={this.props.navigatorStore.adminColor}
                      onChange={() => {
                        if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                          this.props.navigatorStore.setSmartmenuTopItemEnableLikes();
                        } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                          this.props.navigatorStore.setTopItemEnableLikes();
                        }
                        this.forceUpdate();
                      }}
                      style={{
                        marginTop: 20
                      }}
                    />
                    <IAToggle
                      label={this.localizationService.strings.Navigator_Content_EnableComments}
                      checked={selectedTopItem.config.enableComments !== undefined ? selectedTopItem.config.enableComments : true}
                      color={this.props.navigatorStore.adminColor}
                      onChange={() => {
                        if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                          this.props.navigatorStore.setSmartmenuTopItemEnableComments();
                        } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                          this.props.navigatorStore.setTopItemEnableComments();
                        }
                        this.forceUpdate();
                      }}
                      style={{
                        marginTop: 20
                      }}
                    />
                    <div className={adminStyles.panelDivider} />
                    <IAToggle
                      label={this.localizationService.strings.Navigator_Content_ShouldFilterByCategory}
                      checked={selectedTopItem.config.shouldFilterByCategory !== undefined ? selectedTopItem.config.shouldFilterByCategory : false}
                      color={this.props.navigatorStore.adminColor}
                      onChange={() => {
                        if (selectedTopItem != undefined) {
                          this.setState({ categoryValues: undefined });
                        }
                        selectedTopItem.config.shouldFilterByCategory = selectedTopItem.config.shouldFilterByCategory != undefined ? !selectedTopItem.config.shouldFilterByCategory : true;
                        if (selectedTopItem.config.shouldFilterByCategory) {
                          selectedTopItem.config.showFilter = false;
                        }
                        this.props.navigatorStore.checkForChanges();
                        this.forceUpdate();
                      }}
                      style={{
                        marginTop: 20
                      }}
                    />
                    {selectedTopItem.config.shouldFilterByCategory &&
                      <IATermCheckbox
                        environment={this.props.navigatorStore.environment}
                        token={this.props.navigatorStore.token}
                        tenant={this.props.navigatorStore.tenant.replace(".sharepoint.com", "")}
                        instance={selectedTopItem.config.instance}
                        component={"Event"}
                        selectedValues={selectedTopItem.config.selectedCategories}
                        highlightColor={this.props.navigatorStore.adminColor}
                        onChange={(selectedValues) => {
                          let categories = [];
                          selectedValues.forEach((item) => {
                            categories.push({ id: item.id, name: item.defaultLabel });
                          });
                          selectedTopItem.config.selectedCategories = categories;
                          this.props.navigatorStore.checkForChanges();
                          this.forceUpdate();
                        }}
                      />
                    }
                    <IAToggle
                      label={this.localizationService.strings.Navigator_Content_IsTargetingAvailable}
                      checked={selectedTopItem.config.isTargetingAvailable !== undefined ? selectedTopItem.config.isTargetingAvailable : true}
                      color={this.props.navigatorStore.adminColor}
                      onChange={() => {
                        selectedTopItem.config.isTargetingAvailable = selectedTopItem.config.isTargetingAvailable != undefined ? !selectedTopItem.config.isTargetingAvailable : false;
                        this.props.navigatorStore.checkForChanges();
                        this.forceUpdate();
                      }}
                      style={{
                        marginTop: 20
                      }}
                    />
                  </>
                }
                {selectedTopItem.type == "ai" &&
                  <TopItemSettingsAiConfiguration
                    selectedTopItem={selectedTopItem}
                  />
                }
                <div className={adminStyles.panelDivider} />
                {showTargetOptions &&
                  <div style={{
                    marginTop: "20px", clear: "both", float: "left", width: "100%", fontSize: "14px"
                  }}>
                    {this.props.navigatorStore.applicationSettings?.applicationSettings?.toLowerCase() === "profile data" ?
                      <TreeTargeting
                        application={"navigator"}
                        environment={this.props.navigatorStore.environment}
                        tenant={this.props.navigatorStore.tenant}
                        applicationData={this.props.navigatorStore.applicationSettings}
                        instance={this.props.navigatorStore.instance}
                        authToken={this.props.navigatorStore.token}
                        apiUrl={Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}
                        selectedValues={this.selectedValues}
                        operator={selectedTopItem.targeting ? selectedTopItem.targeting.operator : "AND"}
                        showTarget={selectedTopItem.targeting ? selectedTopItem.targeting.enabled : false}
                        currenNodeStructure={selectedTopItem.targetingExistingStructure}
                        onShowTargetChanged={(showTarget: boolean) => {
                          if (!selectedTopItem.targeting) {
                            selectedTopItem.targeting = {
                              enabled: showTarget,
                              operator: "AND"
                            };
                          } else {
                            selectedTopItem.targeting.enabled = showTarget;
                          }

                          if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                            this.props.navigatorStore.updateSmartmenuTopIteTargeting(selectedTopItem.targeting);
                          } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                            this.props.navigatorStore.updateTargeting(selectedTopItem.targeting);
                          }
                          this.props.navigatorStore.checkForChanges();
                        }}
                        onChange={(targeting, applicationSettings, groups, _selectAll, targetingExistingStructure) => {

                          // Processing targeting values
                          if (targeting) {
                            selectedTopItem.targeting.targetingFields = Utils.processReturnTreeTargeting(targeting);
                          }

                          // Processing targeting group data
                          if (groups) {
                            selectedTopItem.targeting.groupData = JSON.stringify(groups);
                            selectedTopItem.targeting.targetingGroups = [];

                            if (groups.length > 0) {
                              groups.forEach((x) => {
                                selectedTopItem.targeting.targetingGroups.push(x.id.toString());
                              });
                            }
                          }

                          if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                            this.props.navigatorStore.updateSmartmenuTopIteTargeting(selectedTopItem.targeting);
                          } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                            this.props.navigatorStore.updateTargeting(selectedTopItem.targeting);
                          }

                          this.setState({ applicationSettings: applicationSettings });
                          this.props.navigatorStore.applicationSettings = applicationSettings;
                          selectedTopItem.targetingExistingStructure = targetingExistingStructure;
                          this.props.navigatorStore.checkForChanges();
                        }}
                        highlightColor={this.props.navigatorStore.adminColor}
                        onLogicalOperatorChanged={(operator: string) => {
                          selectedTopItem.targeting.operator = operator;
                          if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                            this.props.navigatorStore.updateSmartmenuTopIteTargeting(selectedTopItem.targeting);
                          } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                            this.props.navigatorStore.updateTargeting(selectedTopItem.targeting);
                          }
                        }}
                        nodeComparison={"label"}
                      />
                      :
                      <TreeTargetingForGroups
                        environment={this.props.navigatorStore.environment}
                        tenant={this.props.navigatorStore.tenant.replace(".sharepoint.com", "")}
                        application={"navigator"}
                        applicationData={this.props.navigatorStore.applicationSettings}
                        selectedGroupIds={selectedTopItem?.targeting?.targetingGroups}
                        highlightColor={this.props.navigatorStore.adminColor}
                        showTarget={selectedTopItem.targeting != null ? selectedTopItem.targeting.enabled : false}
                        onShowTargetChanged={(showTarget: boolean) => {
                          if (!selectedTopItem.targeting) {
                            selectedTopItem.targeting = {
                              enabled: showTarget,
                              operator: "AND"
                            };
                          } else {
                            selectedTopItem.targeting.enabled = showTarget;
                          }
                          this.props.navigatorStore.checkForChanges();
                        }}
                        onGroupIdsUpdated={(ids: number[]) => {
                          selectedTopItem.targeting.targetingGroups = ids;
                          this.forceUpdate();
                          this.props.navigatorStore.checkForChanges();
                        }}
                      />
                    }
                    <div className={adminStyles.panelDivider} />
                  </div>
                }
                <div style={{
                  clear: "both", float: "left", width: "100%", fontSize: "14px"
                }}>
                  {!this.props.navigatorStore.isCreatingContent &&
                    <div
                      className={adminStyles.settingsPanelDeleteButton}
                      onClick={() => {
                        if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                          this.props.navigatorStore.deleteSelectedSmartmenuTopItem();
                        } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                          this.props.navigatorStore.deleteSelectedTopItem();
                        }
                      }}
                      style={{
                        backgroundColor: "#eeeeee"
                      }}
                    >
                      <div
                        className={adminStyles.settingsPanelDeleteButtonIcon}
                      >
                        <IAIcon
                          title="Trash"
                          size={20}
                          color="#333333"
                        />
                      </div>
                      <div
                        className={adminStyles.settingsPanelDeleteButtonText}
                        style={{
                          color: "#333333"
                        }}
                      >
                        {this.localizationService.strings.Navigator_TopItemPanel_Delete}
                      </div>
                    </div>
                  }
                  <div
                    className={adminStyles.settingsPanelDeleteButton}
                    onClick={() => {
                      if (localStorage.getItem(`navigator-${this.props.navigatorStore.instanceId}`) !== undefined && !this.props.navigatorStore.isCreatingContent) {
                        const originalNavigator = JSON.parse(localStorage.getItem(`navigator-${this.props.navigatorStore.instanceId}`));
                        if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                          this.props.navigatorStore.navigator.smartmenu.elements[this.props.navigatorStore.smartmenuTopItemIndexToEdit] = originalNavigator.smartmenu.elements[this.props.navigatorStore.smartmenuTopItemIndexToEdit];
                        } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                          this.props.navigatorStore.navigator.megamenu.topItems[this.props.navigatorStore.topItemIndexToEdit] = originalNavigator.megamenu.topItems[this.props.navigatorStore.topItemIndexToEdit];
                        }
                        this.props.navigatorStore.checkForNewContent();
                        this.props.navigatorStore.topItemIndexToEdit = undefined;
                        this.props.navigatorStore.smartmenuTopItemIndexToEdit = undefined;
                        this.props.navigatorStore.toggleTopItemSettings();
                      }
                      if (this.props.navigatorStore.isCreatingContent) {
                        if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                          this.props.navigatorStore.deleteSelectedSmartmenuTopItem();
                        } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                          this.props.navigatorStore.deleteSelectedTopItem();
                        }
                      }
                    }}
                    style={{
                      backgroundColor: "#eeeeee"
                    }}
                  >
                    <div className={adminStyles.settingsPanelDeleteButtonText}>
                      {this.localizationService.strings.Navigator_TopItemPanel_Cancel}
                    </div>
                  </div>
                </div>
              </>
            }
            {this.props.navigatorStore.isShowingTopItemSettings && (this.props.navigatorStore.droppableSmartmentTopItemSpotsAreShowing || this.props.navigatorStore.droppableTopItemSpotsAreShowing) &&
              <>
                {pages}
              </>
            }
          </div>
        </div>
      );
    } else {
      return (<></>);
    }
  }
}